export type Env = 'local' | 'dev' | 'work' | 'test' | 'staging' | 'prod';
export type EnvMap = Record<Env, string>;

export const backEndSvcUrls: EnvMap = {
  local: 'https://svc.dev.gfiber.net',
  work: 'https://svc.dev.gfiber.net',
  dev: 'https://svc.dev.gfiber.net',
  test: 'https://svc.tst.gfiber.net',
  staging: 'https://svc.stg.gfiber.net',
  prod: 'https://svc.gfiber.net',
};

export const backEndSvcGrpcUrls: EnvMap = {
  local: 'dns:///address-search-971984652616.us-central1.run.app',
  work: 'dns:///svc.dev.gfiber.net',
  dev: 'dns:///svc.dev.gfiber.net',
  test: 'dns:///svc.tst.gfiber.net',
  staging: 'dns:///svc.stg.gfiber.net',
  prod: 'dns:///svc.gfiber.net',
};

export const backEndEgressUrls: EnvMap = {
  local: 'api.dev.gfiber.net',
  work: 'api.dev.gfiber.net',
  dev: 'api.dev.gfiber.net',
  test: 'api.tst.gfiber.net',
  staging: 'api.stg.gfiber.net',
  prod: 'api.gfiber.net',
};

export enum LobbyType {
  UNSPECIFIED_LOBBY = 'UNSPECIFIED_LOBBY',
  FREE_BASIC_UPGRADE = 'FREE_BASIC_UPGRADE',
  NON_PAY = 'NON_PAY',
}

export const LobbyHeaderEntryId = 'Xj5X6GNY9GmorgrCbCxTw';
export const LobbyFooterEntryId = '1w9cuLFlkstXe9PPSZ650n';

export const ZipcodeRegex = /^\d{5}(-\d{4})?$/;
export enum OutageStatusType {
  UNKNOWN = 'UNKNOWN',
  ADDRESS_API_ERROR = 'ADDRESS_API_ERROR',
  ADDRESS_NOT_FOUND = 'ADDRESS_NOT_FOUND',
  NO_OUTAGE = 'NO_OUTAGE',
  OUTAGE_INFO = 'OUTAGE_INFO',
  NO_OUTAGE_TICKET = 'NO_OUTAGE_TICKET',
}

export enum LobbyAvailableActions {
  UNSPECIFIED_ACTION = 'UNSPECIFIED_ACTION',
  WALK_IN = 'WALK_IN',
  WALK_OUT = 'WALK_OUT',
  PLAN_CHANGE = 'PLAN_CHANGE',
  BILL_PAY = 'BILL_PAY',
}

export const EnvShortNames: EnvMap = {
  dev: 'dev',
  test: 'tst',
  staging: 'stg',
  prod: '',
  local: 'dev',
  work: 'dev',
};
export type VanityDomain = 'google' | 'gfiber';
export type VanitySlug = 'paybill' | 'connectme';
export const GoogleVanityUrlsMap: Record<VanitySlug, EnvMap> = {
  paybill: {
    local: 'https://fiberportal-dev.sandbox.google.com/a/account/billing',
    work: 'https://fiberportal-dev.sandbox.google.com/a/account/billing',
    dev: 'https://fiberportal-dev.sandbox.google.com/a/account/billing',
    test: 'https://fiber.sandbox.google.com/a/account/billing',
    staging: 'https://fiberportal-nightly.sandbox.google.com/a/account/billing',
    prod: 'https://google.com/fiber/paybill',
  },
  connectme: {
    local:
      'https://fiberportal-dev.sandbox.google.com/a/account/manage_plan/internet/plans',
    work: 'https://fiberportal-dev.sandbox.google.com/a/account/manage_plan/internet/plans',
    dev: 'https://fiberportal-dev.sandbox.google.com/a/account/manage_plan/internet/plans',
    test: 'https://fiber.sandbox.google.com/a/account/manage_plan/internet/plans',
    staging:
      'https://fiberportal-nightly.sandbox.google.com/a/account/manage_plan/internet/plans',
    prod: 'https://google.com/fiber/connectme',
  },
};
export const GfiberVanityUrlsMap: Record<VanitySlug, EnvMap> = (() => {
  const gfiberVanityBase = 'https://gfiber.com/go';
  const paybillDevUrl = `${gfiberVanityBase}/paybill-dev`;
  const connectmeDevUrl = `${gfiberVanityBase}/connectme-dev`;
  return {
    paybill: {
      local: paybillDevUrl,
      work: paybillDevUrl,
      dev: paybillDevUrl,
      test: `${gfiberVanityBase}/paybill-tst`,
      staging: `${gfiberVanityBase}/paybill-stg`,
      prod: `${gfiberVanityBase}/paybill`,
    },
    connectme: {
      local: connectmeDevUrl,
      work: connectmeDevUrl,
      dev: connectmeDevUrl,
      test: `${gfiberVanityBase}/connectme-tst`,
      staging: `${gfiberVanityBase}/connectme-stg`,
      prod: `${gfiberVanityBase}/connectme`,
    },
  };
})();

export const LOBBY_ACCOUNT_ID_LENGTH = {
  ENCRYPTED: {MIN: 101, MAX: 499},
  RAW: {MIN: 16, MAX: 50},
} as const;

export const OUTAGE_RECAPTCHA_ACTION = 'outageForm';
export const GRACEFUL_EXCEPTION_LOBBY_ACCOUNT_ID = 'no-account';
export const REDIRECTION_TIME_404 = 0;
export const GFIBER_404 = 'https://gfiber.com/404/';
export const REDIRECTION_SNACKBAR_MESSAGE = 'redirecting to gfiber.com/404 ...';
